<template>
  <div class="border dborder prelative dinline-block vtop cpointer fs14 br2 tleft" v-on:click="goDetail(item.id)">
    <div class="dt pabsolute tc12 tcenter">
      <div class="fs24 mb5">{{day}}</div>
      <div class="fs12">{{month}}</div>
    </div>
    <div class="txt">
      <div class="fs16 fbold mb10 nm ofhidden">{{item.title}}</div>
      <div class="tc9 lh18 int ofhidden">{{info}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "news-item-two",
  data(){
    return {
      day:'01',
      month:'12',
      info:'',
    }
  },
  props:[
    'item',
    'index',
  ],
  methods:{
    goDetail (id){
      this.$router.push({path:'/news/detail',query:{id:id}})
    },
    updateMD(){
      var date = new Date(this.item.release_time);
      var dateTime = date.getTime() / 1000;
      this.month = this.$request.date('Y-m',dateTime);
      this.day = this.$request.date('d',dateTime);
      this.info = this.item.detail.replace(/<.*?>|\&.*\;/ig, "");
    },
  },
  mounted() {
    this.updateMD();
  },
  updated() {
    this.updateMD();
  },
}
</script>
<style scoped>
  .index-wrap .newsdiv .sdiv:hover img{transform: scale(1.05);}
  .index-wrap .newsdiv .sdiv{margin: 0 12px 25px;width: 300px;*width: 290px;width: 290px;}
  .index-wrap .newsdiv .sdiv:nth-child(4n){margin-right: 0;}
  .index-wrap .newsdiv .sdiv:nth-child(4n + 1){margin-left: 0;}
  .index-wrap .newsdiv .nm{height: 22px;}
  .index-wrap .newsdivs{width: 300px;height: 200px;}
  .index-wrap .newsdiv .border:hover{box-shadow: 0 0 15px #ccc;}
  .index-wrap .newsdiv .border:hover .nm{color: #316f3e;}
  .index-wrap .newsdiv .border{margin: 0 10px 20px;width: 410px;height: 160px;}
  .index-wrap .newsdiv .border:nth-of-type(5){margin-left: 0;}
  .index-wrap .newsdiv .border:nth-of-type(7){margin-right: 0;}
  .index-wrap .newsdiv .txt{padding: 25px 10px 0 70px;}
  .index-wrap .newsdiv .dt{left: 0;top: 20px;width: 70px;}
  .index-wrap .newsdiv .int{height: 80px;}
</style>



// WEBPACK FOOTER //
// src/components/index/news-item-two.vue